import React from 'react';
import { useTranslation } from 'react-i18next';

import { separatorContainerStyle, separatorTextStyle } from './styles';

interface DateSeparatorProps {
  date: Date;
}

const DateSeparator: React.FC<DateSeparatorProps> = ({ date }) => {
  const { i18n, t } = useTranslation();

  const formatMessageDate = (date: Date): string => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const messageDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

    if (messageDate.getTime() === today.getTime()) {
      return t('chat.date_separator.today');
    }

    if (messageDate.getTime() === yesterday.getTime()) {
      return t('chat.date_separator.yesterday');
    }

    // For other dates use toLocaleDateString like in PremiumBanner
    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      // Only show year if it's different from current year
      ...(date.getFullYear() !== now.getFullYear() && { year: 'numeric' })
    };

    return date.toLocaleDateString(i18n.language, options);
  };

  return (
    <div style={separatorContainerStyle}>
      <span style={separatorTextStyle}>{formatMessageDate(date)}</span>
    </div>
  );
};

export default DateSeparator;
